import { render, staticRenderFns } from "./snapshotPic.vue?vue&type=template&id=3b86d317&scoped=true&"
import script from "./snapshotPic.vue?vue&type=script&lang=ts&"
export * from "./snapshotPic.vue?vue&type=script&lang=ts&"
import style0 from "./snapshotPic.vue?vue&type=style&index=0&id=3b86d317&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86d317",
  null
  
)

export default component.exports